import { useNavigate } from "react-router-dom";
import { Network } from "lucide-react";
import { Button } from "@/ui";
import { useOpenContact } from "@/app/navigation";
import { ConnectionsGraph } from "./ConnectionsGraph";
import s from "../shared.module.css";

/** The person page's Connections section: a small radial map, a click opens the person, the link opens the full map. */
export function ConnectionsSection({ contactId }: { contactId: string }) {
  const navigate = useNavigate();
  const open = useOpenContact();
  return (
    <div className={s.section}>
      <div className="u-row" style={{ justifyContent: "space-between", marginBottom: 6 }}>
        <span className="u-row" style={{ gap: 6, fontWeight: 600 }}><Network size={14} /> Connections</span>
        <Button size="sm" variant="ghost" onClick={() => navigate(`/people/map?view=connections&from=${encodeURIComponent(contactId)}`)}>Open in Map</Button>
      </div>
      <div className="u-small u-muted" style={{ marginBottom: 6 }}>People on the same meetings and emails, related people, shared groups and Hub links. Hover for the why; click to open.</div>
      <ConnectionsGraph contactId={contactId} limit={12} height={440} onCenter={(id) => open(id)} />
    </div>
  );
}
